import { useEffect, useCallback, useRef } from 'react';

export const useUnsavedChangesWarning = (hasUnsavedChanges) => {
  const hasChangesRef = useRef(hasUnsavedChanges);

  useEffect(() => {
    hasChangesRef.current = hasUnsavedChanges;
  }, [hasUnsavedChanges]);

  const handleBeforeUnload = useCallback((e) => {
    if (!hasChangesRef.current) return;
    e.preventDefault();
    e.returnValue = '';
  }, []);

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [handleBeforeUnload]);
};
